import { UtilityService } from '@eforall/common';
import { GridColumn, buildColumn } from '@eforall/dashboard';
import { GoalsAndProgress } from '@interfaces';


export function getColumns(util: UtilityService) {

	const columns: GridColumn<GoalsAndProgress, unknown>[] = [
		buildColumn(util, 'Id', row => row.accGoalId, { header: 'accEntrepreneurId' }),
		buildColumn(util, 'Id', row => row.accVentureId, { header: 'accVentureId' }),
		buildColumn(util, 'Text', row => row.ventureName, { header: 'Venture Name', group: 'asc' }),
		buildColumn(util, 'Text', row => row.summary, { header: 'Summary' }),
		buildColumn(util, 'Text', row => row.status, { header: 'Status' }),
		buildColumn(util, 'Text', row => row.category, { header: 'Category' }),
		buildColumn(util, 'Number', row => row.commentsCount.progress, { header: '# Progress Updates' }),
		buildColumn(util, 'Date', row => row.lastProgressUpdatedUTC ? util.date.fromUTC(row.lastProgressUpdatedUTC) : undefined, { header: 'Last Progress Update' }),
		buildColumn(util, 'Number', row => row.commentsCount.mentor, { header: '# Mentor Comments' }),
		buildColumn(util, 'Number', row => row.commentsCount.staff, { header: '# Staff Comments' }),
		buildColumn(util, 'Text', row => row.updatedByPersonName, { header: 'Last Updated By', hidden: true }),
		buildColumn(util, 'Date', row => util.date.fromUTC(row.createdUTC), { header: 'Last Updated Date', hidden: true }),
		buildColumn(util, 'Text', row => row.createdByPersonName, { header: 'Created By', hidden: true }),
		buildColumn(util, 'Date', row => util.date.fromUTC(row.createdUTC), { header: 'Created Date', hidden: true }),
	];


	return columns;

}